import clinicAPI from "../services/clinicApi";

export function countUpcomingTrainerSessions(sessions = []) {
  const now = Date.now();
  return sessions.filter((session) => {
    if (session.status === "cancelled") return false;
    const start = new Date(session.start_datetime).getTime();
    return Number.isFinite(start) && start >= now;
  }).length;
}

export async function loadUpcomingTrainerSessions(trainerId, days = 90) {
  const from = new Date();
  const to = new Date(from);
  to.setDate(to.getDate() + days);
  const res = await clinicAPI.getTrainingSessions({
    doctor_id: trainerId,
    from: from.toISOString().slice(0, 10),
    to: to.toISOString().slice(0, 10),
  });
  return countUpcomingTrainerSessions(res.sessions || []);
}
